var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgFinancialActivities(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "29px",
    height: "29px",
    viewBox: "0 0 29 29",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.00260869565 0.0385058971 0.00260869565 17.9550662 14.9704348 17.9550662 14.9704348 0.0385058971"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SELECT-REPORT-TYPE-v1",
    transform: "translate(-505.000000, -587.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(505.000000, 587.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-15",
    fill: "#91CA9C",
    cx: 14.5,
    cy: 14.5,
    r: 14.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "money-bag",
    transform: "translate(7.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9704348,14.61204 C14.9704348,18.12573 11.6313043,17.924085 7.48521739,17.924085 C3.33917391,17.924085 0,18.096885 0,14.61204 C0,11.09853 3.33917391,5.25204 7.48521739,5.25204 C11.6313043,5.28084 14.9704348,11.12733 14.9704348,14.61204 Z",
    id: "Fill-1",
    fill: "#F2B233",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.48521739,5.28084 C11.6313043,5.28084 14.9704348,11.12733 14.9704348,14.64084 C14.9704348,18.15453 11.6313043,17.95293 7.48521739,17.95293",
    id: "Fill-3",
    fill: "#DD981D",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.84,1.65204 C3.84,-0.04707 5.48165217,0.03924 7.48521739,0.03924 C9.4886087,0.03924 11.1304348,-0.04707 11.1304348,1.65204 C11.1304348,3.351285 9.4886087,6.202485 7.48521739,6.202485 C5.48165217,6.202485 3.84,3.351285 3.84,1.65204 Z",
    id: "Fill-4",
    fill: "#F2B233",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.48521739,0.03924 C9.4886087,0.03924 11.1304348,-0.04707 11.1304348,1.65204 C11.1304348,3.351285 9.4886087,6.202485 7.48521739,6.202485",
    id: "Fill-5",
    fill: "#DD981D",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.6853043,5.597595 C10.6853043,5.88573 10.4626522,6.115995 10.1842609,6.115995 L4.786,6.115995 C4.50782609,6.115995 4.28517391,5.88573 4.28517391,5.597595 L4.28517391,5.45364 C4.28517391,5.16573 4.50782609,4.935285 4.786,4.935285 L10.2121304,4.935285 C10.4904783,4.935285 10.7129565,5.16573 10.7129565,5.45364 L10.7129565,5.597595 L10.6853043,5.597595 Z",
    id: "Fill-7",
    fill: "#04AF76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.7026087,4.964085 L10.2121304,4.964085 C10.4904783,4.964085 10.7129565,5.19453 10.7129565,5.482485 L10.7129565,5.62644 C10.7129565,5.91453 10.4347826,6.144795 10.1566087,6.144795",
    id: "Fill-8",
    fill: "#008C61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8243913,12.250395 C10.8243913,14.159205 9.32930435,15.70644 7.48521739,15.70644 C5.64113043,15.70644 4.14604348,14.159205 4.14604348,12.250395 C4.14604348,10.341765 5.64113043,8.79453 7.48521739,8.79453 C9.32930435,8.79453 10.8243913,10.341765 10.8243913,12.250395 Z",
    id: "Fill-9",
    fill: "#04AF76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.12008696,9.802485 C6.42782609,8.448795 8.5426087,8.448795 9.8503913,9.802485 C11.1583043,11.155995 11.1583043,13.344795 9.8503913,14.69853",
    id: "Fill-10",
    fill: "#008C61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.20704348,15.044085 L7.20704348,14.324085 C6.65047826,14.295285 6.34443478,14.18013 6.09391304,14.035995 L6.26086957,13.25853 C6.53904348,13.402485 6.90082609,13.54644 7.31826087,13.54644 C7.68004348,13.54644 7.93034783,13.402485 7.93034783,13.143195 C7.93034783,12.884085 7.73573913,12.74013 7.23469565,12.56733 C6.53904348,12.336885 6.09391304,11.991285 6.09391304,11.357595 C6.09391304,10.78173 6.34443478,10.32084 7.17917391,10.176885 L7.17917391,9.57204 L7.73573913,9.57204 L7.73573913,10.14804 C8.29213043,10.176885 8.48691304,10.263195 8.68173913,10.37853 L8.51478261,11.12733 C8.34782609,11.04084 8.06965217,10.896885 7.59647826,10.896885 C7.17917391,10.896885 7.04008696,11.069685 7.04008696,11.271285 C7.04008696,11.50173 7.26256522,11.616885 7.81913043,11.84733 C8.57047826,12.135285 8.87652174,12.48084 8.87652174,13.08573 C8.87652174,13.690395 8.57047826,14.18013 7.73573913,14.324085 L7.73573913,15.044085 L7.20704348,15.044085 Z",
    id: "Fill-11",
    fill: "#FFF7E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.48521739,9.57204 L7.48521739,10.896885 L7.62430435,10.896885 C8.09730435,10.896885 8.37569565,11.04084 8.5426087,11.12733 L8.70956522,10.37853 C8.48691304,10.263195 8.31995652,10.14804 7.76343478,10.14804 L7.76343478,9.57204 L7.48521739,9.57204 Z",
    id: "Fill-12",
    fill: "#FFEEBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.84695652,11.81853 C7.70786957,11.76084 7.5686087,11.703195 7.48521739,11.67453 L7.48521739,12.65364 C7.76343478,12.797595 7.93034783,12.94173 7.93034783,13.143195 C7.93034783,13.37364 7.76343478,13.488795 7.48521739,13.54644 L7.48521739,15.044085 L7.76343478,15.044085 L7.76343478,14.295285 C8.59834783,14.151285 8.9043913,13.66173 8.9043913,13.056885 C8.9043913,12.45204 8.59834783,12.10644 7.84695652,11.81853 Z",
    id: "Fill-13",
    fill: "#FFEEBD"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinancialActivities);
export default __webpack_public_path__ + "static/media/financial-activities.6f25f3db7a84fc151cd9296dfc4de3cd.svg";
export { ForwardRef as ReactComponent };